var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{on:{"click":_vm.show_popup}},[_c('i',{staticClass:"el-icon-circle-plus-outline"}),_c('span',[_vm._v("Add user")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }